export default "__VITE_ASSET__BbGwU6nT__"